import { useCallback } from 'react';

import { sanitizeRichText } from '@onark/shared/sanitizeRichText';

import { useFeatureFlag } from '../app/_components/FeatureFlags';

/**
 * Render admin-authored rich text, sanitized, unless the kill switch is off.
 *
 * Returns a function rather than a string so a component can call it once per
 * item inside a `.map()` (branch paths, completion boxes) without breaking the
 * rules of hooks.
 *
 * The flag reaches here through the snapshot `withAuth` puts in page props and
 * `pages/_app` feeds to FeatureFlagProvider, so server and client decide the
 * same way and `dangerouslySetInnerHTML` cannot flip between the two. Without a
 * provider the context answers the declared fallback, which is ON.
 */
export function useRichText(): (html: string | null | undefined) => string {
  const sanitize = useFeatureFlag('rich-text-sanitize');

  return useCallback(
    (html: string | null | undefined) =>
      sanitize ? sanitizeRichText(html) : html || '',
    [sanitize]
  );
}
